import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../../contexts/AuthContext';
import lavenderIconLight from '../../assets/blue_unfilled_icon_light.png';
import lavenderIconDark from '../../assets/lavender_unfilled_icon_dark.png';

const API_URL = '/api';

function PasswordReset() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { darkMode } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Validate passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    // Get token from URL query params
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setError('Invalid reset link. No token provided.');
      return;
    }

    setStatus('loading');

    try {
      const response = await axios.post(`${API_URL}/reset-password`, { token, password });
      setStatus('success');
      setMessage(response.data.message || 'Password reset successfully! You can now log in with your new password.');

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.error || 'Password reset failed. Please try again or request a new reset link.');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-logo">
          <h1>
            <img src={darkMode ? lavenderIconDark : lavenderIconLight} alt="Ref-Lex Icon" style={{ height: '3em', verticalAlign: 'bottom', marginRight: '0.3em' }} />
            <span className="logo-text">Ref-Lex</span>
          </h1>
          <p className="tagline">Another Reference Manager</p>
        </div>
        <h2>Reset Password</h2>

        {status === 'success' ? (
          <div className="success">
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>✓</div>
            <p>{message}</p>
            <p style={{ marginTop: '15px', fontSize: '14px', color: 'var(--text-secondary)' }}>
              Redirecting to login...
            </p>
          </div>
        ) : (
          <div>
            {error && <div className="error">{error}</div>}
            {message && <div className="success">{message}</div>}
            <form onSubmit={handleSubmit}>
              <input
                type="password"
                placeholder="New Password (12+ chars, uppercase, lowercase, number)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={status === 'loading'}
                minLength="12"
                title="Password must be at least 12 characters with uppercase, lowercase, and number"
              />
              <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={status === 'loading'}
                minLength="12"
              />
              <button type="submit" disabled={status === 'loading'}>
                {status === 'loading' ? 'Resetting Password...' : 'Reset Password'}
              </button>
            </form>
            <p style={{ marginTop: '15px', textAlign: 'center' }}>
              <button
                onClick={() => navigate('/login')}
                className="link-button"
                disabled={status === 'loading'}
              >
                Back to Login
              </button>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PasswordReset;
